import { PageComponentsProvider, PageProvider } from '@namespace/cms';
import { Layout } from '../Page/Layout';
import { PageRouterWrapper } from '../PageRouterWrapper';

/**
 * This component enables the rendering of a CMS page within
 * the container of another page. The component overrides the
 * `pathname` for both `PageComponentsProvider` and `PageProvider`,
 * ensuring that the appropriate data is fetched for the desired
 * page to be rendered.
 *
 * Notably, the current implementation does not include a `Wrapper`,
 * meaning that elements such as the `Header` and `Footer` are not present.
 *
 * @example
 * import { PageInContainer } from '@namespace/layout';
 * import { FALLBACK_PAGES } from 'components/Page/api';
 * ...
 * export const LoginPageModal = () => {
 *  ...
 *  return (
 *      ...
 *      <PageInContainer
 *          FALLBACK_PAGES={FALLBACK_PAGES}
 *          pagePath="/login/"
 *      />
 *      ...
 *  );
 *}
 */
export const PageInContainer = ({
  pagePath,
  FALLBACK_PAGES,
  componentsMap = {},
  initialPageConfig = {},
  layoutType
}) => (
  <PageComponentsProvider componentsMap={componentsMap}>
    <PageProvider
      pagePath={pagePath}
      FALLBACK_PAGES={FALLBACK_PAGES}
      initialPageConfig={initialPageConfig}
    >
      <PageRouterWrapper FALLBACK_PAGES={FALLBACK_PAGES} pagePath={pagePath}>
        <Layout customLayoutType={layoutType} />
      </PageRouterWrapper>
    </PageProvider>
  </PageComponentsProvider>
);
